export const bg_home = 'https://assets.nflxext.com/ffe/siteui/vlv3/36a4db5b-dec2-458a-a1c0-662fa60e7473/1115a02b-3062-4dcc-aae0-94028a0dcdff/IN-en-20240820-TRIFECTA-perspective_WEB_eeff8a6e-0384-4791-a703-31368aeac39f_large.jpg'

export const step1_image = 'https://assets.nflxext.com/ffe/siteui/acquisition/simplicity/Devices.png'

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer ' + process.env.REACT_APP_TMDB_KEY
    }
}

export const POSTER_URL = "https://image.tmdb.org/t/p/w780/"

export const LANGUAGE = [{identifier: 'en', name:'English'}, {identifier: 'hindi', name: 'Hindi'}, {identifier: 'jp', name: 'Japanese'}]

export const Groq_KEY = process.env.REACT_APP_GROQ_KEY
